"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactsEpics = exports.loadContactsEpic = exports.filterContactsEpic = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxObservable = require("redux-observable");

var R = _interopRequireWildcard(require("ramda"));

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _contacts = require("./contacts.actions");

var _contacts2 = require("./contacts.selectors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var buildRequestParams = function buildRequestParams(params) {
  return R.pipe(function (values) {
    return _objectSpread(_objectSpread({}, params), {}, {
      page: values.page || 1,
      perPage: 15
    });
  }, _utils.pickNotEmptyAndNil)(params);
};

var filterContactsEpic = function filterContactsEpic(action$) {
  return action$.pipe((0, _reduxObservable.ofType)(_contacts.setContactsFilters.getType()), (0, _operators.debounceTime)(500), (0, _operators.mergeMap)(function () {
    return [(0, _contacts.resetContacts)(), (0, _contacts.loadContactsRequest)(1)];
  }));
};

exports.filterContactsEpic = filterContactsEpic;

var loadContactsEpic = function loadContactsEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_contacts.loadContactsRequest.getType()), (0, _operators.debounceTime)(500), (0, _operators.mergeMap)(function (_ref2) {
    var payload = _ref2.payload;
    var filters = (0, _contacts2.getContactsFilters)(state$.value);
    return createGiftService.getAvailableContacts(buildRequestParams(_objectSpread(_objectSpread({}, filters), {}, {
      page: payload
    }))).pipe((0, _operators.map)(function (_ref3) {
      var users = _ref3.users,
          meta = _ref3.meta;
      return (0, _contacts.loadContactsSuccess)({
        users,
        meta
      });
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _contacts.loadContactsFail
    })), (0, _operators.takeUntil)(action$.ofType(_contacts.loadContactsRequest, _contacts.setContactsFilters)));
  }));
};

exports.loadContactsEpic = loadContactsEpic;
var contactsEpics = [loadContactsEpic, filterContactsEpic];
exports.contactsEpics = contactsEpics;